import { SM_CONSTANTS } from "src/app/shared/constants/sm-constants";
import { FcmNotification } from "./../../../models/common";
import { Component, Inject, OnDestroy, OnInit } from "@angular/core";
import {
  MAT_DIALOG_DATA,
  MatDialog,
  MatDialogRef,
} from "@angular/material/dialog";
import { ApiService } from "src/app/providers/api.service";
import { InvoiceComponent } from "../invoice/invoice.component";
import { Subscription } from "rxjs";
import { LoaderServiceService } from "src/app/providers/loader-service.service";
import { CustomConfirmDialogComponent } from "../custom-confirm-dialog/custom-confirm-dialog.component";

@Component({
  selector: "sm-record-payment-for-fitness",
  templateUrl: "./record-payment-for-fitness.component.html",
  styleUrls: ["./record-payment-for-fitness.component.scss"],
})
export class RecordPaymentForFitnessComponent implements OnInit, OnDestroy {
  isEntityForeign: string = localStorage.getItem(
    SM_CONSTANTS.IS_ENTITY_FOREIGN,
  )!;
  public newbookingData: any = {
    price: 0,
  };
  toShowNotify: boolean = false;
  notAllowedNumbers = [
    "0000000000",
    "1111111111",
    "2222222222",
    "3333333333",
    "4444444444",
    "5555555555",
    "6666666666",
    "7777777777",
    "8888888888",
    "9999999999",
    "1234567890",
    "1000000000",
  ];
  countryInfo: any =
    typeof sessionStorage.getItem(
      SM_CONSTANTS.CURRENCY_FOR_SUBSCRIPTION_PAYMENT,
    ) == "string"
      ? JSON.parse(
          sessionStorage.getItem(
            SM_CONSTANTS.CURRENCY_FOR_SUBSCRIPTION_PAYMENT,
          )!,
        )
      : sessionStorage.getItem(SM_CONSTANTS.CURRENCY_FOR_SUBSCRIPTION_PAYMENT);

  customerPayment: any;

  private _apiSubscription: Subscription = new Subscription();
  selectedBookingType: number = 1;
  selectedPaymentMode: string = "Cash";
  serviceList: any = [];
  constructor(
    @Inject(MAT_DIALOG_DATA) public parentData: any,
    private _apiService: ApiService,
    public _modelRef: MatDialog,
    private loader: LoaderServiceService,
    private activemodal: MatDialogRef<RecordPaymentForFitnessComponent>,
  ) {}
  ngOnInit(): void {
    console.log(this.parentData.data);
    this.customerPayment = this.parentData.data.payment_due;
    this.toShowNotify = !this.notAllowedNumbers.includes(
      this.parentData.data.cust_phone,
    );

    // let data = this.parentData.data

    // this._apiService.getServicesTypesList(data.entityHash,'0',data.serviceType)

    this._apiSubscription = this._apiService.apiResult.subscribe((resData) => {
      if (
        resData.responseType === SM_CONSTANTS.RESULT_API_RECORD_FITNESS_INVOICE
      ) {
        if (resData.result) {
          this.activemodal.close();
        }
      }
      if (
        resData.responseType ===
        SM_CONSTANTS.RESULT_API_ADD_EDIT_FITNESS_INTERNATIONAL_INVOICE_PAYMENT_RECORD
      ) {
        if (resData.result) {
          this.activemodal.close();
        }
      }
    });
  }
  notify: boolean = false;

  onPost() {
    console.log(this.parentData.data);
    if (this.selectedPaymentMode == "Wallet") {
      if (
        this.availableWalletCash &&
        this.availableWalletCash >= this.customerPayment
      ) {
        // let appointments: { appointment_hash_id: any; is_primary: number }[] =
        //   [];
        // if (this.parentData.data.appArr) {
        //   this.parentData.data.appArr.forEach((element: any) => {
        //     if (
        //       element.appointment_id == this.parentData.data.appointmentHash
        //     ) {
        //       let data = {
        //         appointment_hash_id: element.appointment_id,
        //         is_primary: 1,
        //       };
        //       appointments.push(data);
        //     } else {
        //       let data = {
        //         appointment_hash_id: element.appointment_id,
        //         is_primary: 0,
        //       };
        //       appointments.push(data);
        //     }
        //   });
        // }
        let data = {
          total_price: this.parentData.data.price,
          customer_payment: this.customerPayment,
          net_price: this.parentData.data.netPay,
          payment_status: 1,
          currency: this.countryInfo.currency,
          currency_symbol: this.countryInfo.currencySymbol,
          payment_mode: this.selectedPaymentMode,
          invoice_hash: this.parentData.data.invId,
          employee_hash_id: localStorage.getItem(
            SM_CONSTANTS.OWNER_EMPLOYEE_HASH_ID,
          ),
          customer_country_code: this.parentData.data.customer_country_code,
          customer_phone: this.parentData.data.customer_phone,
          customer_name: this.parentData.data.customer_name,
          // is_paying_due: this.parentData.data.netPay == this.parentData.data.payment_due ? 0 : 1,
          is_paying_due: 1,
          entity_hash: this.parentData.data.entityHash,
          member_hash: this.parentData.data.memberHash ?? null,
          payment_time: this.formatDateString(),
          notify: this.notify === true ? 1 : 0,
          payment_type: this.parentData.data.memberHash ? 2 : 3,
          created_by: localStorage.getItem(SM_CONSTANTS.KEY_ACCOUNT_HASH_ID),
        };

        Object.keys(data).forEach((key) => {
          if ((data as any)[key] === null) {
            delete (data as any)[key];
          }
        });

        console.log(data);
        this.loader.showLoader = true;
        if (this.isEntityForeign == "0") {
          this._apiService.addEditFitnessInvoicePaymentRecord(data);
        } else if (this.isEntityForeign == "1") {
          this._apiService.addEditFitnessInternationalInvoicePaymentRecord(
            data,
          );
        }
      } else {
        const dialogRef = this._modelRef.open(CustomConfirmDialogComponent, {
          data: {
            title: "Insufficient wallet cash!",
            message:
              "Not enough wallet cash to pay the amount. Use other methods.",
            okbtn: "OK",
            cancelbtn: "Cancel",
            type: SM_CONSTANTS.CUSTOM_DIALOG_ALERT_TYPE,
          },
          disableClose: true,
        });
        this.changeChip("Cash");
      }
    } else {
      // let appointments: { appointment_hash_id: any; is_primary: number }[] = [];
      // if (this.parentData.data.appArr) {
      //   this.parentData.data.appArr.forEach((element: any) => {
      //     if (element.appointment_id == this.parentData.data.appointmentHash) {
      //       let data = {
      //         appointment_hash_id: element.appointment_id,
      //         is_primary: 1,
      //       };
      //       appointments.push(data);
      //     } else {
      //       let data = {
      //         appointment_hash_id: element.appointment_id,
      //         is_primary: 0,
      //       };
      //       appointments.push(data);
      //     }
      //   });
      // }
      let data = {
        total_price: this.parentData.data.price,
        customer_payment: this.customerPayment,
        net_price: this.parentData.data.netPay,
        payment_status: 1,
        currency: this.countryInfo.currency,
        currency_symbol: this.countryInfo.currencySymbol,
        payment_mode: this.selectedPaymentMode,
        invoice_hash: this.parentData.data.invId,
        employee_hash_id: localStorage.getItem(
          SM_CONSTANTS.OWNER_EMPLOYEE_HASH_ID,
        ),
        customer_country_code: this.parentData.data.customer_country_code,
        customer_phone: this.parentData.data.customer_phone,
        customer_name: this.parentData.data.customer_name,
        // is_paying_due: this.parentData.data.netPay == this.parentData.data.payment_due ? 0 : 1,
        is_paying_due: 1,
        entity_hash: this.parentData.data.entityHash,
        member_hash: this.parentData.data.memberHash ?? null,
        payment_time: this.formatDateString(),
        notify: this.notify === true ? 1 : 0,
        payment_type: this.parentData.data.memberHash ? 2 : 3,
        created_by: localStorage.getItem(SM_CONSTANTS.KEY_ACCOUNT_HASH_ID),
      };

      Object.keys(data).forEach((key) => {
        if ((data as any)[key] === null) {
          delete (data as any)[key];
        }
      });

      console.log(data);
      this.loader.showLoader = true;
      if (this.isEntityForeign == "0") {
        this._apiService.addEditFitnessInvoicePaymentRecord(data);
      } else if (this.isEntityForeign == "1") {
        this._apiService.addEditFitnessInternationalInvoicePaymentRecord(data);
      }
    }
  }

  availableWalletCash: number = 0;
  toShowWallet: boolean = false;
  walletCs: any;
  changeChip(value: string) {
    this.selectedPaymentMode = value;
    if (this.selectedPaymentMode == "Wallet") {
      this.loader.showLoader = true;
      this._apiService
        .getWalletMoneyForEntityCustomer(
          localStorage.getItem(
            SM_CONSTANTS.CURRENT_ENTITY_PUBLIC_PROFILE_HASH_ID,
          ),
          this.parentData.data.customer_country_code,
          this.parentData.data.cust_phone,
        )
        .subscribe({
          next: (res: any) => {
            this.toShowWallet = true;
            if (res) {
              this.loader.showLoader = false;
              // if (
              //   res?.wallet_amount &&
              //   res?.wallet_amount >= this.customerPayment
              // ) {
              //   // SHOW THE APPLIED WALLET CASH
              //   this.availableWalletCash = res?.wallet_amount;
              //   this.walletCs = res?.currency_symbol
              // } else {

              //   const dialogRef = this._modelRef.open(
              //     CustomConfirmDialogComponent,
              //     {
              //       data: {
              //         title: "Insufficient wallet cash!",
              //         message:
              //           "Not enough wallet cash to pay the amount. Use other methods.",
              //         okbtn: "OK",
              //         cancelbtn: "Cancel",
              //         type: SM_CONSTANTS.CUSTOM_DIALOG_ALERT_TYPE,
              //       },
              //       disableClose: true,
              //     }
              //   );
              //   this.changeChip("Cash");
              // }
              this.availableWalletCash = res?.wallet_amount ?? 0;
              this.walletCs =
                res?.currency_symbol ?? this.countryInfo.currencySymbol;
            } else {
              this.loader.showLoader = false;
              this.availableWalletCash = 0;
              this.walletCs = this.countryInfo.currencySymbol;
              // const dialogRef = this._modelRef.open(
              //     CustomConfirmDialogComponent,
              //     {
              //       data: {
              //         title: "Insufficient wallet cash!",
              //         message:
              //           "Not enough wallet cash to pay the amount. Use other methods.",
              //         okbtn: "OK",
              //         cancelbtn: "Cancel",
              //         type: SM_CONSTANTS.CUSTOM_DIALOG_ALERT_TYPE,
              //       },
              //       disableClose: true,
              //     }
              //   );
              //   this.changeChip("Cash");
            }
          },
          error: (err: any) => {
            console.error(">>> [Wallet amount fetch error]:", err);
            this.loader.showLoader = false;
            this.toShowWallet = false;
            this.changeChip("Cash");
            // window.location.reload();
          },
        });
    } else {
      this.availableWalletCash = 0;
      this.toShowWallet = false;
    }
  }

  formatDateString(): string {
    const now = new Date();

    const options: Intl.DateTimeFormatOptions = {
      timeZone: "Asia/Kolkata",
      year: "numeric",
      month: "2-digit",
      day: "2-digit",
      hour: "2-digit",
      minute: "2-digit",
      second: "2-digit",
      hour12: false, // Ensures 24-hour format
    };

    const formattedDate = new Intl.DateTimeFormat(
      "en-CA",
      options,
    ).formatToParts(now);

    let year = "",
      month = "",
      day = "",
      hours = "",
      minutes = "",
      seconds = "";

    formattedDate.forEach((part) => {
      if (part.type === "year") year = part.value;
      if (part.type === "month") month = part.value;
      if (part.type === "day") day = part.value;
      if (part.type === "hour") hours = part.value;
      if (part.type === "minute") minutes = part.value;
      if (part.type === "second") seconds = part.value;
    });

    return `${year}-${month}-${day} ${hours}:${minutes}:${seconds}`;
  }

  ngOnDestroy(): void {
    this._apiSubscription.unsubscribe();
  }
}
